import { routes as printRoutes } from "./prints/routes";

export const routes = (prefix = `billing`) => [
    {
        name: `${prefix}.proforma-invoice.create`,
        path: `/${prefix}/proforma-invoice/create/:patientId/:visitNo`,
        component: () => import('./Form.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.proforma-invoice.create`,
                PageDescription: "Accounts: Proforma Invoice",
            },
        },
    },
    ...printRoutes(prefix),
];
